import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

const AuthContext = createContext({
  session: null,
  profile: null,
  loading: true,
});

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const loadProfile = async (currentSession) => {
      if (!currentSession?.user) {
        if (active) {
          setProfile(null);
          setLoading(false);
        }
        return;
      }
      const user = currentSession.user;
      let { data, error } = await supabase
        .from("profiles")
        .select("id, email, name, type")
        .eq("id", user.id)
        .single();

      if (error && (error.code === "PGRST116" || error.status === 406)) {
        const meta = user.user_metadata || {};
        const desiredType = ["student", "teacher"].includes(meta.type)
          ? meta.type
          : "student";
        const { error: upsertError } = await supabase
          .from("profiles")
          .upsert({
            id: user.id,
            email: user.email,
            name: meta.name || "",
            type: desiredType,
          });
        if (!upsertError) {
          const res = await supabase
            .from("profiles")
            .select("id, email, name, type")
            .eq("id", user.id)
            .single();
          data = res.data;
          error = res.error;
        }
      }

      if (active) {
        setProfile(data || null);
        setLoading(false);
      }
    };

    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      loadProfile(data.session);
    });

    const { data: subscription } = supabase.auth.onAuthStateChange(
      (_event, currentSession) => {
        setSession(currentSession);
        if (!currentSession) {
          setProfile(null);
          setLoading(false);
        } else {
          loadProfile(currentSession);
        }
      }
    );

    return () => {
      active = false;
      subscription.subscription.unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ session, profile, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
